import { Skeleton } from '@/components/shadcn/skeleton'
import { useRestClient } from '@/contexts/QueryProvider'
import { DmpChatAgentForm } from '@/features/dmp-chat/components/DmpChatAgentForm'
import { SectionLayout } from '@/pages/shared-components/SectionLayout'
import { ErrorComponent } from '@/ui-legacy/ErrorComponent'
import { AgentStudioBreadcrumbs } from '../AgentStudioBreadcrumbs'
import { useNavigate, useParams } from 'react-router'

export const AgentStudioAgentPage = () => {
  const navigate = useNavigate()
  const { agentId: routeAgentId } = useParams()
  const agentId = Number(routeAgentId)
  const hasValidAgentId = Number.isInteger(agentId)
  const { getUserAgentApiGetUserAgent } = useRestClient()
  const {
    data: agent,
    isError,
    isLoading,
  } = getUserAgentApiGetUserAgent.useQuery({ path: { agentId } }, { enabled: hasValidAgentId })
  const agentName = agent ? (agent.name ?? agent.config.name ?? agent.config.key) : isLoading ? 'Loading...' : 'Agent'

  return (
    <>
      <AgentStudioBreadcrumbs title="Agents" agentName={agentName} />
      <SectionLayout>
        {isLoading ? (
          <Skeleton className="h-32 w-full" />
        ) : isError || !hasValidAgentId || !agent ? (
          <ErrorComponent />
        ) : (
          <DmpChatAgentForm layout="grid" selectedAgent={agent} onDelete={() => navigate('/agent-studio/agents')} />
        )}
      </SectionLayout>
    </>
  )
}
